var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultsIllustation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_5305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5 119C96.4949 119 120 95.4949 120 66.5C120 37.505 96.4949 14 67.5 14C38.505 14 15 37.505 15 66.5C15 95.4949 38.505 119 67.5 119Z",
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 66.5,
    r: 42,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.998 123.555L113.898 112.399",
    stroke: "#AAB9CB",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 8.375C82.2868 8.375 76.375 12.973 76.375 27.9167C76.375 38.3528 79.2582 43.7432 87.5417 46.0455V58.625L98.7429 47.4237C99.6299 47.4472 100.549 47.4583 101.5 47.4583C120.713 47.4583 126.625 42.8602 126.625 27.9167C126.625 12.973 120.713 8.375 101.5 8.375Z",
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 8.375C82.2868 8.375 76.375 12.973 76.375 27.9167C76.375 38.3528 79.2582 43.7432 87.5417 46.0455V58.625L98.7429 47.4237C99.6299 47.4472 100.549 47.4583 101.5 47.4583C120.713 47.4583 126.625 42.8602 126.625 27.9167C126.625 12.973 120.713 8.375 101.5 8.375Z",
    fill: "#AAB9CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.797 21.5962L95.5975 34.7955",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.802 34.7949L95.6024 21.5956",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_5305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 12.4444,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsIllustation);
export default __webpack_public_path__ + "static/media/no-results-illustation.6f003c5d2d4aed8bd8555b6f1a4842d1.svg";
export { ForwardRef as ReactComponent };